import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ProjectService from "../services/ProjectService";
import ProjectStoreService from "../services/ProjectStoreService";
import StoreService from "../services/StoreService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import { useNavigate } from "react-router-dom";
import utility from "../utils/utility";
import EmployeePermissionService from "../services/EmployeePermissionService";
import ScreenData from "../config/ScreenData";
import ReactPaginate from "react-paginate";
import usePermission from "../utils/UsePermission";
import MessageDialog from "../components/MessageDialog";

export default function AddProjectStore() {
  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [assignedStores, setAssignedStores] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // for save button / loader
  const [showModal, setShowModal] = useState(false);

  // PAGE-LEVEL MESSAGE (top of table)
  const [pageMessage, setPageMessage] = useState("");
  const [pageMsgType, setPageMsgType] = useState("error");

  // MODAL-LEVEL MESSAGE (inside popup)
  const [modalMessage, setModalMessage] = useState("");
  const [modalMsgType, setModalMsgType] = useState("error");

  const [editData, setEditData] = useState(null);
  const [selected, setSelected] = useState("");
  // const [messageTimer, setMessageTimer] = useState(null);

  const { register, getValues, reset } = useForm();

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;


  // --------------------------------
  // Helpers for auto-hide messages
  // --------------------------------
  const showPageMessage = (msg, type = "error") => {
    setPageMessage(msg);
    setPageMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);
    // const timer = setTimeout(() => setPageMessage(""), 3000);
    // setMessageTimer(timer);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Project_Stores,
    showPageMessage
  );

  // useEffect(() => {
  //   if (permission) {
  //     checkView();
  //   }
  // }, [permission]);

  const showModalMessage = (msg, type = "error") => {
    setModalMessage(msg);
    setModalMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);
    // const timer = setTimeout(() => setModalMessage(""), 3000);
    // setMessageTimer(timer);
  };

  // --------------------------------
  // Init data
  // --------------------------------
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setSelected("");
  }, [assignedStores, selectedProjectId]);




  useEffect(() => {
    setCurrentPage(1);
  }, [assignedStores, selectedProjectId]);

  const init = async () => {
    try {
      const companyId = StorageService.activeCompany().companyId;
      const projRes = await ProjectService.getActive(companyId);
      setProjects(projRes?.data || projRes || []);

      const storeRes = await StoreService.getActive();
      const storeList = storeRes?.data || storeRes || [];
      setStores(storeList);
    } catch (err) {
      console.error("Init error:", err);
      showPageMessage("Failed to load initial data", "danger");
    }
  };

  // --------------------------------
  // Load assigned stores per project
  // --------------------------------
  // const loadAssignedStores = async (projectId) => {
  //   if (!projectId) {
  //     setAssignedStores([]);
  //     setSelected([]);
  //     return;
  //   }

  //   try {
  //     if (!permission || !checkView()) {
  //       setAssignedStores([]);
  //       return;
  //     }
  //     const storeRes = await StoreService.getActive();
  //     const storeList = storeRes?.data || storeRes || [];
  //     setStores(storeList);

  //     const res = await ProjectStoreService.getAll(currentPage, itemsPerPage);
  //     // const list = res?.data || res || [];

  //     const list = res?.data?.data || [];

  //     // const filtered = Array.isArray(list)
  //     //   ? list.filter((x) => String(x.projectId) === String(projectId))
  //     //   : [];

  //     // const enriched = filtered.map((item) => {
  //     //   const store = storeList.find((s) => s.id === item.storeId);
  //     //   return {
  //     //     ...item,
  //     //     storeName: store?.storeName || "N/A",
  //     //     storeCode: store?.storeCode || "N/A",
  //     //   };
  //     // });

  //     setAssignedStores(list);
  //     // setPageCount(res?.totalPages > 0 ? res.totalPages : 1);
  //     setPageCount(res?.pagination?.totalPages || 1);
  //     setSelected([]);
  //   } catch (error) {
  //     console.error("Failed to fetch project stores:", error);
  //     showPageMessage("Failed to load assigned stores", "danger");
  //     setAssignedStores([]);
  //   }
  // };

  const loadAssignedStores = async (projectId) => {
    if (!projectId) {
      setAssignedStores([]);
      setSelected([]);
      return;
    }

    try {
      if (!permission || !checkView()) {
        setAssignedStores([]);
        return;
      }

      const storeRes = await StoreService.getActive();
      const storeList = storeRes?.data || storeRes || [];
      setStores(storeList);

      const res = await ProjectStoreService.getAll(currentPage, itemsPerPage);
      const list = res?.data?.data || [];

      const filtered = list.filter(
        (x) => String(x.projectId) === String(projectId)
      );

      const enriched = filtered.map((item) => {
        const store = storeList.find(
          (s) => String(s.id) === String(item.storeId)
        );
        return {
          ...item,
          storeName: store?.storeName || "N/A",
          storeCode: store?.storeCode || "N/A",
        };
      });

      setAssignedStores(enriched);
      setPageCount(res?.pagination?.totalPages || 1);
      setSelected([]);
    } catch (error) {
      console.error(error);
      showPageMessage("Failed to load assigned stores", "danger");
      setAssignedStores([]);
    }
  };

  // --------------------------------
  // Fetch data for Modify
  // --------------------------------
  const fetchModifyData = async (id) => {
    try {
      const record = await ProjectStoreService.getById(id);

      if (!record) {
        showPageMessage("Failed to load store details!", "danger");
        return;
      }

      reset({
        storeId: record.storeId,
        fromKMS: record.fromKMS,
        toKMS: record.toKMS,
      });

      setEditData(record);
      setShowModal(true);

    } catch (error) {
      console.error("Modify fetch error:", error);
      showPageMessage("Failed to load store details!", "danger");
    }
  };

  const handleModify = async () => {
    setPageMessage("");

    if (!can("canModify")) {
      showPageMessage("No Modify Permission", "danger");
      return;
    }
    if (assignedStores.length === 0) {
      showPageMessage("No records found to modify.", "danger");
      return;
    }

    if (!selected) {
      showPageMessage("Please select a record to modify.", "danger");
      return;
    }

    // 🔥 Find from currently loaded rows
    const row = assignedStores.find(
      (s) => String(s.id) === String(selected)
    );

    if (!row) {
      showPageMessage("Selected record not found.", "danger");
      return;
    }

    await fetchModifyData(selected);
  };

  // const indexOfLast = currentPage * itemsPerPage;
  // const indexOfFirst = indexOfLast - itemsPerPage;

  // const currentData = assignedStores.slice(
  //   indexOfFirst,
  //   indexOfLast
  // );

  useEffect(() => {
    if (permission && checkView() && selectedProjectId) {
      loadAssignedStores(selectedProjectId);
    }
  }, [currentPage, permission, selectedProjectId]);


  // --------------------------------
  // Add button click
  // --------------------------------
  const handleAddClick = () => {
    setPageMessage("");
    setEditData(null);
    setSelected("");
    if (!can("canAdd")) {
      showPageMessage("No Add Permission", "danger");
      return;
    }

    if (!selectedProjectId) {
      showPageMessage("Select a project to add", "danger");
      return;
    }

    reset({
      storeId: "",
      fromKMS: "",
      toKMS: "",
    });
    setModalMessage("");
    setShowModal(true);
  };

  const handleSelect = (id) => {
    setSelected(id);
  };

  // --------------------------------
  // Save / Update
  // --------------------------------
  const handleSave = async () => {
    setModalMessage("");

    const data = getValues();

    if (!can(editData ? "canModify" : "canAdd")) {
      showModalMessage("No Permission", "danger");
      return;
    }

    if (
      !selectedProjectId ||
      !data.storeId ||
      data.fromKMS === "" ||
      data.toKMS === ""
    ) {
      showModalMessage("Please fill all required fields!", "danger");
      return;
    }

    // No negative values allowed
    if (data.fromKMS < 0 || data.toKMS < 0) {
      showModalMessage("KMS values cannot be negative!", "danger");
      return;
    }

    // toKMS must be greater than fromKMS
    if (Number(data.toKMS) <= Number(data.fromKMS)) {
      showModalMessage("To KMS must be greater than From KMS!", "danger");
      return;
    }

    if (!selectedProjectId) {
      showModalMessage("Please select a project first!", "danger");
      return;
    }

    if (!data.storeId) {
      showModalMessage("Please select a store", "danger");
      return;
    }

    const payload = {
      projectId: selectedProjectId,
      storeId: data.storeId,
      fromKMS: data.fromKMS || 0,
      toKMS: data.toKMS || 0,
      companyId: StorageService.activeCompany().companyId,
      status: "Active",
      createdBy: StorageService.loginData().employeeId,
      updatedBy: StorageService.loginData().employeeId,
    };

    setLoading(true);

    try {
      if (editData) {
        await ProjectStoreService.update(editData.id, payload);
        showModalMessage("Store updated successfully!", "success");
      } else {
        await ProjectStoreService.create(payload);
        showModalMessage("Store assigned successfully!", "success");
      }

      await loadAssignedStores(selectedProjectId);

      setTimeout(() => {
        setShowModal(false);
        reset({
          storeId: "",
          fromKMS: "",
          toKMS: "",
        });
        setEditData(null);
      }, 800);
    } catch (err) {
      console.error("Save error:", err);

      let backendMessage = "Backend Error!";

      if (err.response && err.response.data) {
        backendMessage =
          err.response.data.message ||   // our backend sends this
          err.response.data.error ||
          err.response.data ||
          "Backend Error!";
      }

      showModalMessage(backendMessage, "danger");
    } finally {
      setLoading(false);
    }
  };

  if (!permission) return null;

  if (permission.canView !== 1) {
    return (
      <div className="text-center mt-5 text-danger">
        You do not have permission to view this screen
      </div>
    );
  }

  const handleStatusToggle = async (id, currentStatus) => {
    if (!can("canModify")) {
      showPageMessage("You don't have permission to modify status", "error");
      return;
    }

    const action =
      currentStatus === "Active"
        ? "Inactive"
        : "Active";

    const confirmed = window.confirm(
      `Are you sure you want to change the status to ${action}?`
    );

    if (!confirmed) return;

    try {
      await ProjectStoreService.updateStatus(id);

      await loadAssignedStores(selectedProjectId);

      showPageMessage(
        `Status changed to ${action} successfully`,
        "success"
      );

    } catch (err) {
      showPageMessage(
        err?.response?.data?.message ||
        "Failed to update status",
        "danger"
      );
    }
  };
  return (
    <>
      <Breadcrumb pageTitle="Assign Project Stores" secondTitle="Projects" />
      <MessageDialog
        message={pageMessage || modalMessage}
        type={
          (pageMsgType === "success" || modalMsgType === "success")
            ? "success"
            : "error"
        }
        setMessage={() => {
          setPageMessage("");
          setModalMessage("");
        }}
        setMsgType={() => { }}
      />

      <div className="row">
        {/* Project Dropdown */}
        <div className="card p-3 mb-3">
          <label className="form-label">Project</label>
          <select
            className="form-select w-50"
            onChange={(e) => {
              const pid = e.target.value;
              setSelectedProjectId(pid);
              setSelected("");          // ✅ clear radio
              setPageMessage("");
              // loadAssignedStores(pid);
            }}
          >
            <option value="">Select Project</option>
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.projectName}-{p.projectCode}
              </option>
            ))}
          </select>
        </div>

        {/* Assigned Stores Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Assigned Stores</h5>

            <div>
              {can("canAdd") && (
                <button
                  className="btn btn-success me-2"
                  onClick={handleAddClick}
                >
                  <i className="ti ti-plus me-1"></i> Add Stores
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  onClick={handleModify}
                  disabled={!selected}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}
            </div>
          </div>

          <div className="card-body">
            {/* Page-level message */}
            {/* {pageMessage && (
              <div
                className={`alert alert-${pageMsgType} d-flex justify-content-between align-items-center py-2`}
              >
                <span>{pageMessage}</span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setPageMessage("")}
                ></button>
              </div>
            )} */}

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Store Name</th>
                  <th>From KMS</th>
                  <th>To KMS</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {assignedStores.length > 0 ? (
                  assignedStores.map((s) => (
                    <tr key={s.id}>
                      <td>
                        <input
                          type="radio"
                          checked={String(selected) === String(s.id)}
                          onChange={() => handleSelect(s.id)}
                        />
                      </td>
                      <td>
                        {s.storeName} - {s.storeCode}
                      </td>
                      <td>{s.fromKMS}</td>
                      <td>{s.toKMS}</td>
                      <td>
                        <span
                          className={`badge ${s.status === "Active"
                            ? "bg-success"
                            : "bg-danger"
                            }`}
                          style={{
                            cursor: "pointer",
                            padding: "8px 12px"
                          }}
                          onClick={() => handleStatusToggle(s.id, s.status)}
                          title="Click to change status"
                        >
                          {s.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No assigned stores
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <ReactPaginate
            // forcePage={currentPage - 1}
            forcePage={Math.max(0, currentPage - 1)}
            breakLabel="..."
            nextLabel="Next >"
            previousLabel="< Previous"
            onPageChange={(e) => setCurrentPage(e.selected + 1)}
            pageCount={pageCount}   // ✅ IMPORTANT
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
          />
        </div>

        {/* MODAL */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "420px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <h5>{editData ? "Modify Store" : "Assign Store"}</h5>

              {/* Modal-level message */}
              {/* {modalMessage && (
                <div className={`alert alert-${modalMsgType} py-2`}>
                  {modalMessage}
                </div>
              )} */}

              <div className="mb-3">
                <label className="form-label">Store</label>
                <select className="form-select" {...register("storeId")}>
                  <option value="">Select Store</option>
                  {stores.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.storeName} - {s.storeCode}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">From KMS</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("fromKMS")}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">To KMS</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("toKMS")}
                />
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowModal(false);
                    setEditData(null);
                    reset({
                      storeId: "",
                      fromKMS: "",
                      toKMS: "",
                    });
                  }}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={
                    loading || !can(editData ? "canModify" : "canAdd")
                  }
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editData
                      ? "Updating..."
                      : "Saving..."
                    : editData
                      ? "Update"
                      : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
